module.exports = __webpack_public_path__ + "static/media/infoJumbo2.f2a80959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/aalbers/images/infoJumbo2.jpg
// module id = 568
// module chunks = 0